import { render, staticRenderFns } from "./ResourceModulePage.vue?vue&type=template&id=bfd6fe92&"
import script from "./ResourceModulePage.vue?vue&type=script&lang=ts&"
export * from "./ResourceModulePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports